import { useNavigate } from 'react-router-dom';
import type { ReactNode } from 'react';

interface Props {
  name: string;
  description: string;
  icon: ReactNode;
  status: 'active' | 'coming-soon';
  granted?: boolean; // Default true für Backward-Compat
  href?: string;
}

export function ToolCard({ name, description, icon, status, granted, href }: Props) {
  const navigate = useNavigate();
  const isActive = status === 'active';
  const isActiveAndGranted = isActive && (granted ?? true);
  const showNotGranted = isActive && granted === false;

  return (
    <button
      type="button"
      onClick={() => isActiveAndGranted && href && navigate(href)}
      disabled={!isActiveAndGranted}
      className={`
        flex flex-col items-start gap-3 rounded-2xl border border-border bg-card p-6 text-left
        transition-colors
        ${isActiveAndGranted
          ? 'hover:border-primary cursor-pointer'
          : 'opacity-60 cursor-not-allowed'}
      `}
      title={
        isActiveAndGranted
          ? undefined
          : showNotGranted
          ? 'Nicht für dich freigeschaltet — frag deinen Coach'
          : 'Kommt bald'
      }
    >
      <div className="text-primary">{icon}</div>
      <div className="space-y-1">
        <h3 className="text-base font-semibold">
          {name}
          {!isActive && (
            <span className="ml-2 inline-flex items-center rounded-full bg-secondary-tint px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider text-secondary">
              kommt bald
            </span>
          )}
          {showNotGranted && (
            <span className="ml-2 inline-flex items-center rounded-full bg-muted px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider text-muted-foreground">
              nicht freigeschaltet
            </span>
          )}
        </h3>
        <p className="text-sm text-muted-foreground">{description}</p>
        {showNotGranted && (
          <p className="text-xs text-muted-foreground italic">
            Frag deinen Coach, ob er dir dieses Werkzeug freischaltet.
          </p>
        )}
      </div>
    </button>
  );
}
